import { useEffect } from 'react';
import { blockFirstQuestionVital } from 'features/monitoring/firstQuestionVital';

export const useBlockFirstQuestionVital = (when = true): void => {
  useEffect(() => {
    if (when) blockFirstQuestionVital();
  }, [when]);
};
